import React from 'react';
import styled from 'styled-components';

import Top from '../top';

const StyledScholarship = styled.section`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	padding: 4rem 1rem 6rem;
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;

	@media (max-width: 500px) {
		padding: 2rem 1rem;
	}

	.inner {
		text-align: center;
		color: white;
		max-width: 1000px;

		h2 {
			max-width: 500px;
			margin: 0 auto 2rem;
		}
	}
`;

const Scholarship = ({ data }) => (
	<StyledScholarship style={{ backgroundImage: `url(${data.background})` }}>
		<div className="inner">
			<Top color="blue">SCHOLARSHIPS</Top>
			<h2>{data.title}</h2>
			<p>{data.copy}</p>
		</div>
	</StyledScholarship>
);

export default Scholarship;
